module.exports = __webpack_public_path__ + "static/assets/00819232fa65505d81ac42a8d3bef89b.png";